const { throttle } = require("lodash")

$(() => {
  const $recruit_fixed_link = $('.recruit-fixed-link')
  const $footer = $('.footer')

  $(window).on('load scroll', throttle(() => {
    if(window.scrollY + window.innerHeight >= $footer.offset().top) {
      $recruit_fixed_link.fadeOut()
    }else {
      $recruit_fixed_link.fadeIn()
    }
  }, 120))
})